import type { NodeSpec } from "prosemirror-model";

export const emojiNode: NodeSpec = {
  inline: true,
  attrs: {
    alt: {},
    src: {},
  },
  group: "inline",
  parseDOM: [
    {
      tag: "img.emoji",
      priority: 60, // Higher than the default (50)
      getAttrs(dom) {
        if (typeof dom === "string") {
          return null;
        }

        return { src: dom.getAttribute("src"), alt: dom.getAttribute("alt") };
      },
    },
  ],
  toDOM(node) {
    return ["img", { class: "emoji", ...node.attrs }];
  },
};

export const unicodeEmojiNode: NodeSpec = {
  inline: true,
  attrs: {
    class: {},
    text: {},
    title: {},
  },
  group: "inline",
  parseDOM: [
    {
      tag: "span.unicode-emoji",
      priority: 60, // Higher than the default (50)
      getAttrs(dom) {
        if (typeof dom === "string") {
          return null;
        }

        return { class: dom.getAttribute("class"), text: dom.textContent, title: dom.getAttribute("title") };
      },
    },
  ],
  toDOM(node) {
    return ["span", { class: node.attrs.class, title: node.attrs.title }, node.attrs.text];
  },
};
